import React from "react";
import { useNavigate, Link, NavLink, useLocation } from "react-router-dom";
import { reset as resetToken } from "../../features/auth/authSlice";
import { reset as resetUser } from "../../features/profile/profileSlice";
import { getAuth } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import app from "../../config/firebase";

// import logoKG from '../../assets/images/asset-kg/logo-orange.png'

import Logo from "../../assets/images/m-knows-logo.png";
import LogoDark from "../../assets/images/m-knows-logo.png";

import { setTheme, addThemeListeners } from "./themeUtils";
import { useScript } from "../../hooks/useScript";
import { useEffect } from "react";
import Notifikasi from "../notifikasi/notifikasiNavbar/SectionNotifikasi";

const getFirstName = (fullName) => {
  const names = fullName.split(" ");
  return names[0];
};

const Header = () => {
  const auth = getAuth(app);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loaded1, error1] = useScript(
    "bootstrap-bundle",
    "/assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js",
    () => {
      console.log("Script Bootstrap loaded successfully");
    },
    () => {
      console.log("Script Bootstrap failed to load");
    }
  );

  const [loaded2, error2] = useScript(
    "functions",
    "/assets/js/functions.js",
    () => {
      console.log("Script Functions loaded successfully");
    },
    () => {
      console.log("Script Functions failed to load");
    }
  );

  // useScript(
  //   "bootstrap-bundle",
  //   "/assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js"
  // );
  // useScript("functions", "/assets/js/functions.js");

  const onLogout = () => {
    auth.signOut();

    localStorage.removeItem("user");
    localStorage.removeItem("token");

    dispatch(resetUser());
    dispatch(resetToken());

    toast.info("Anda berhasil keluar.");

    if (location.pathname !== "/") navigate("/");
    // else window.location.reload();
  };

  const { user } = useSelector((state) => state.profile);

  useEffect(() => {
    setTheme();
    addThemeListeners();

    return () => {
      document.querySelectorAll("[data-bs-theme-value]").forEach((toggle) => {
        toggle.removeEventListener("click", () => {});
      });
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", () => {});
    };
  }, []);

  return (
    <>
      <header className="navbar-light navbar-sticky">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <Link className="navbar-brand me-0" to="/">
              <img
                className="light-mode-item navbar-brand-item"
                src={Logo}
                alt="LMS M-Knows"
              />
              <img
                className="dark-mode-item navbar-brand-item"
                src={LogoDark}
                alt="LMS M-Knows"
              />
            </Link>
            <button
              className="navbar-toggler ms-auto"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-animation">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <div className="navbar-collapse collapse" id="navbarCollapse">
              <ul className="navbar-nav navbar-nav-scroll mx-auto">
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to="/"
                    style={{ fontSize: "17px" }}
                  >
                    Beranda
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link "
                    to="/kategori"
                    style={{ fontSize: "17px" }}
                  >
                    Fitur
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link "
                    to="/panduan"
                    style={{ fontSize: "17px" }}
                  >
                    Panduan
                  </NavLink>
                </li>
                {/* <li className="nav-item">
									<NavLink
										className="nav-link "
										to="/team"
										style={{ fontSize: "17px" }}
									>
										Team
									</NavLink>
								</li> */}
              </ul>
            </div>
            {user ? (
              <>
                <Notifikasi />
                <div className="dropdown ms-3">
                  <a
                    className="avatar avatar-sm p-0"
                    href="#"
                    id="profileDropdown"
                    role="button"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      className="avatar-img rounded-circle"
                      style={{ border: "1px solid black", padding: "2px" }}
                      src={
                        user.display_picture_link != null
                          ? `${user.display_picture_link}`
                          : "/assets/images/avatar/empty-display-picture.png"
                      }
                      alt={user.fullName}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          "/assets/images/avatar/empty-display-picture.png";
                      }}
                    />
                  </a>
                  <ul
                    className="dropdown-menu dropdown-animation dropdown-menu-end shadow pt-3"
                    aria-labelledby="profileDropdown"
                  >
                    <li className="px-3 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="avatar me-3">
                          <img
                            className="avatar-img rounded-circle shadow"
                            src={
                              user.display_picture_link != null
                                ? `${user.display_picture_link}`
                                : "/assets/images/avatar/empty-display-picture.png"
                            }
                            alt={user.fullName}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "/assets/images/avatar/empty-display-picture.png";
                            }}
                          />
                        </div>
                        <div>
                          <span className="h6">
                            Halo, {getFirstName(user.full_name)}!
                          </span>
                          <p className="small m-0">{user.email}</p>
                        </div>
                      </div>
                      <hr />
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/dashboard">
                        <i className="bi bi-ui-checks-grid fa-fw me-2"></i>
                        Dashboard
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/administrasi">
                        <i className="bi bi-card-list fa-fw me-2"></i>
                        Administrasi
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/profil">
                        <i className="bi bi-person fa-fw me-2"></i>
                        Profil
                      </NavLink>
                    </li>
                    <li>
                      <button
                        className="dropdown-item bg-danger-soft-hover"
                        onClick={onLogout}
                      >
                        <i className="fas fa-sign-out-alt fa-fw me-2"></i>
                        Keluar
                      </button>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    {/* Dark mode options START */}
                    <li>
                      <div className="bg-light dark-mode-switch theme-icon-active d-flex align-items-center justify-content-center p-1 rounded mt-2">
                        <button
                          type="button"
                          className="btn btn-sm mb-0"
                          data-bs-theme-value="light"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-sun fa-fw mode-switch"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
                            <use href="#"></use>
                          </svg>{" "}
                          Light
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm mb-0"
                          data-bs-theme-value="dark"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-moon-stars fa-fw mode-switch"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
                            <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z" />
                            <use href="#"></use>
                          </svg>{" "}
                          Dark
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm mb-0 active"
                          data-bs-theme-value="auto"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-circle-half fa-fw mode-switch"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                            <use href="#"></use>
                          </svg>{" "}
                          Auto
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <>
                <div className="dropdown">
                  <button
                    className="btn btn-light btn-sm lh-1 p-2 mb-0"
                    id="bd-theme"
                    type="button"
                    aria-expanded="false"
                    data-bs-toggle="dropdown"
                    data-bs-display="static"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-circle-half fa-fw theme-icon-active"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"></path>
                      <use href="#"></use>
                    </svg>
                  </button>

                  <ul
                    className="dropdown-menu min-w-auto dropdown-menu-end"
                    aria-labelledby="bd-theme"
                  >
                    <li className="mb-1">
                      <button
                        type="button"
                        className="dropdown-item d-flex align-items-center active"
                        data-bs-theme-value="light"
                      >
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-brightness-high-fill fa-fw mode-switch me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"></path>
                          <use href="#"></use>
                        </svg>
                        Light
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        type="button"
                        className="dropdown-item d-flex align-items-center"
                        data-bs-theme-value="dark"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-moon-stars-fill fa-fw mode-switch me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"></path>
                          <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"></path>
                          <use href="#"></use>
                        </svg>
                        Dark
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item d-flex align-items-center"
                        data-bs-theme-value="auto"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-circle-half fa-fw mode-switch me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"></path>
                          <use href="#"></use>
                        </svg>
                        Auto
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="navbar-nav ms-2">
                  <Link className="btn btn-sm btn-dark mb-0" to="/login">
                    <i className="bi bi-power me-2"></i>Masuk
                  </Link>
                </div>
              </>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
